import UT from '@/common/util';

class I18n {
  constructor(options = {}) {
    this.storage = window.localStorage;
    this.setLocale(this.storage.getItem('app-locale'));
    this.data = options.data || {};
  }

  setLocale(locale) {
    this.locale = locale || 'ko';
    this.storage.setItem('app-locale', this.locale);
  }

  translate(key, ...args) {
    const dataKey = `${this.locale}.${key}`;
    const value = dataKey.split('.').reduce((acc, cur) => {
      if (typeof acc === "object") {
        return acc[cur];
      }
    }, this.data);
    if (UT.isString(value)) {
      return UT.isEmpty(args) ? value : UT.formatString(value, ...args);
    }
    return `?${key}?`;
  }
}

export default I18n;
